<label style="text-align: center;">Query Reference Number - <span class="referanceNumber"> {{queryReferenceNumber}} </span></label>
<br/>

<!-- <button nz-button style="float: right;"> <nz-icon [nzType]="!isTabularView ? 'table' : 'unordered-list'" nzTheme="outline" (click)="toggleView()" /></button> -->
<nz-list *ngIf="!isTabularView" [nzDataSource]="commentTableModel" [nzRenderItem]="item" [nzItemLayout]="'horizontal'">
    <ng-template #item let-item>
      <nz-comment [nzAuthor]="item.CommentedBy" [nzDatetime]="item.CommentedDateTimeString ">
        <nz-avatar nz-comment-avatar nzIcon="user" ></nz-avatar>
        <nz-comment-content>
          <p style="font-size: 90%;">{{ item.Comment }}</p>
        </nz-comment-content>        
      </nz-comment>
    </ng-template>
  </nz-list>

<nz-table *ngIf="isTabularView" #commentsTable [nzData]="commentTableModel" [nzBordered]="true" [nzSize]="'small'" [nzShowPagination]="true" [nzPageSize]="5">
    <thead>
        <tr>        
            <th style="padding: 5px;">Comment Added By</th>
            <th style="padding: 5px;">Comment</th>   
            <th style="padding: 5px;">Date</th>              
        </tr>        
    </thead>
    <tbody>
        <tr *ngFor="let data of commentsTable.data">
            <td>{{ data.CommentedBy}} </td>
            <td>{{ data.Comment}} </td>
            <td>{{ data.CommentedDate | date:'dd-MMM-yyyy HH:mm:ss a'}}</td>            
        </tr>
    </tbody>
</nz-table>
